module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(is_soo){ 
__p+='\n	<div class="tip-row-soo-header '+
((__t=( is_queensland_at_home ? 'revert-bg' : '' ))==null?'':_.escape(__t))+
'">\n		State Of Origin Game '+
((__t=( soo_game_index ))==null?'':_.escape(__t))+
'\n	</div>\n';
 } 
__p+='\n\n<div class="tip-row-men-header">\n	<div class="logo">\n		<img src="/assets/images/nrl-shield-logo-on-light.svg" alt="NRL Premiership Logo">\n	</div>\n	<span>\n		NRL MENS FINAL SERIES\n	</span>\n</div>\n\n\n<div class="top-row">\n	<label for="squad-home-'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="team-label">\n		<div class="squad-name-left">'+
((__t=( home_squad_name ))==null?'':_.escape(__t))+
'</div>\n	</label>\n	';
 if (is_postponed) { 
__p+='\n		<p class="no-margin">Postponed</p>\n	';
 } else if(is_live){ 
__p+='\n		<div class="live-match-label">Live</div>\n	';
 } else if(is_completed) { 
__p+='\n		<p>Match Completed</p>\n	';
 } else { 
__p+='\n		<p>'+
((__t=( game_date ))==null?'':_.escape(__t))+
'</p>\n	';
 } 
__p+='\n	<label for="squad-away-'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="team-label">\n		<div class="squad-name-right">'+
((__t=( away_squad_name ))==null?'':_.escape(__t))+
'</div>\n	</label>\n</div>\n<div class="tip-row">\n	\n	<div class="squad-column home">\n		\n		<div class="squad home-squad">\n			';
 if(is_completed){ 
__p+='\n				<div class="tip-status">\n					';
 if(predict_winner_squad_id === home_squad_id){ 
__p+='\n						';
 if(is_correct){ 
__p+='\n							<div class="'+
((__t=( hidden ? 'autogenerate-wrapper' : 'correct-wrapper' ))==null?'':_.escape(__t))+
'">\n								<img class="correct-icon" src="/assets/images/check.svg"/>\n							</div>\n						';
 } else { 
__p+='\n							<div class="incorrect-wrapper">\n								<img class="incorrect-icon" src="/assets/images/crossWhite.svg" />\n							</div>\n						';
 } 
__p+='\n					';
 } 
__p+='\n				</div>\n			';
 } else { 
__p+='\n				<input type="radio"\n					value="'+
((__t=( home_squad_id ))==null?'':_.escape(__t))+
'"\n					name="squad['+
((__t=( id ))==null?'':_.escape(__t))+
'][]"\n                    class="js-radio-tip"\n					id="squad-home-'+
((__t=( id ))==null?'':_.escape(__t))+
'"\n						'+
((__t=( is_disabled || is_postponed ? 'disabled' : '' ))==null?'':_.escape(__t))+
'\n						'+
((__t=( predict_winner_squad_id === home_squad_id ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n\n				<label for="squad-home-'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="checkbox '+
((__t=( (predict_winner_squad_id !== home_squad_id && is_disabled) ? 'hide-disabled' : '' ))==null?'':_.escape(__t))+
'"></label>\n			';
 } 
__p+='\n\n			<label for="squad-home-'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="logo-home">\n				<figure>\n					<img src="'+
((__t=( image_squads_path + home_squad_id ))==null?'':_.escape(__t))+
'.png" alt="">\n					<figcaption>'+
((__t=( home_squad_name ))==null?'':_.escape(__t))+
'</figcaption>\n				</figure>\n			</label>\n			<div class="score home-score">\n				'+
((__t=( is_disabled ? home_score : '' ))==null?'':_.escape(__t))+
'\n			</div>\n		</div>\n	</div>\n	\n	<div class="game-detail">\n		\n		';
 if(!is_postponed){ 
__p+='\n			<a class="game-more-info js-game-more-info">\n				<span>Game Info</span>\n				';
 if(is_game_info_opened){ 
__p+='\n					<i class="ion-chevron-up"></i>\n				';
 } else { 
__p+='\n					<i class="ion-chevron-down"></i>\n				';
 } 
__p+='\n			</a>\n		';
 } 
__p+='\n	</div>\n	<div class="squad-column away">\n		\n		<div class="squad away-squad">\n			<div class="score away-score">\n				'+
((__t=( is_disabled ? away_score : '' ))==null?'':_.escape(__t))+
'\n			</div>\n			<label for="squad-away-'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="logo-away">\n				<figure>\n					<img src="'+
((__t=( image_squads_path + away_squad_id ))==null?'':_.escape(__t))+
'.png" alt="">\n					<figcaption>'+
((__t=( away_squad_name ))==null?'':_.escape(__t))+
'</figcaption>\n				</figure>\n			</label>\n			\n			';
 if(is_completed){ 
__p+='\n				<div class="tip-status">\n					';
 if(predict_winner_squad_id === away_squad_id){ 
__p+='\n						';
 if(is_correct){ 
__p+='\n							<div class="correct-wrapper">\n								<img class="'+
((__t=( hidden ? 'autogenerate-wrapper' : 'correct-wrapper' ))==null?'':_.escape(__t))+
'" src="/assets/images/check.svg"/>\n							</div>\n						';
 } else { 
__p+='\n							<div class="incorrect-wrapper">\n								<img class="incorrect-icon" src="/assets/images/crossWhite.svg" />\n							</div>\n						';
 } 
__p+='\n					';
 } 
__p+='\n				</div>\n			';
 } else { 
__p+='\n				<input type="radio"\n					value="'+
((__t=( away_squad_id ))==null?'':_.escape(__t))+
'"\n					name="squad['+
((__t=( id ))==null?'':_.escape(__t))+
'][]"\n                       class="js-radio-tip"\n					id="squad-away-'+
((__t=( id ))==null?'':_.escape(__t))+
'"\n				'+
((__t=( is_disabled || is_postponed ? 'disabled' : '' ))==null?'':_.escape(__t))+
'\n				'+
((__t=( predict_winner_squad_id === away_squad_id ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n				<label for="squad-away-'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="checkbox '+
((__t=( (predict_winner_squad_id !== away_squad_id && is_disabled) ? 'hide-disabled' : '' ))==null?'':_.escape(__t))+
'"></label>\n			';
 } 
__p+='\n		</div>\n	</div>\n\n</div>\n\n';
 if(is_margin_game && !is_postponed){ 
__p+='\n<div class="tip-margin">\n	<div class="tip-margin-container">\n		';
 if(!is_disabled){ 
__p+='\n		<button class="tip-margin-less-btn '+
((__t=( is_disabled ? '' : 'js-margin-less' ))==null?'':_.escape(__t))+
'">\n			<i class="ion-chevron-left"></i>\n		</button>\n		';
 } 
__p+='\n		<div class="tip-margin-value-box '+
((__t=( is_disabled ? 'is-disabled' : '' ))==null?'':_.escape(__t))+
'">\n			<div class="tip-margin-value">\n				<input class="js-predict-margin-value"\n					   pattern="[0-9]{1,2}"\n					   type="text"\n					   value="'+
((__t=( predict_margin ))==null?'':_.escape(__t))+
'"\n				'+
((__t=( is_disabled ? 'disabled' : '' ))==null?'':_.escape(__t))+
'>\n			</div>\n			<div class="tip-margin-value-text">'+
((__t=( is_disabled ? 'Your' : 'Enter' ))==null?'':_.escape(__t))+
' margin</div>\n		</div>\n		';
 if(!is_disabled){ 
__p+='\n		<button class="tip-margin-more-btn '+
((__t=( is_disabled ? '' : 'js-margin-more' ))==null?'':_.escape(__t))+
'">\n			<i class="ion-chevron-right"></i>\n		</button>\n		';
 } 
__p+='\n	</div>\n\n	<div class="tooltip-bar">\n		<div class="tooltip-text">\n			<p>Use the arrows on the margin selector to choose your margin or type in your margin for the match</p>\n		</div>\n		<span class="tooltip-icon">?</span>\n	</div>\n</div>\n';
 } 
__p+='\n\n';
 if(is_odds_visible && is_adult && !is_completed){ 
__p+='\n	<div class="bet-details">\n		<div class="currency home-squad">\n			';
 if(is_mobile) { 
__p+='\n			<a target="_blank" href="https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252167;dc_trk_aid=521056745;dc_trk_cid=148493239;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=">\n				';
 } else { 
__p+='\n				<a target="_blank" href="https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252164;dc_trk_aid=521058920;dc_trk_cid=148493239;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=">\n					';
 } 
__p+='\n					'+
((__t=( home_squad_odds_currency ))==null?'':_.escape(__t))+
'\n				</a>\n		</div>\n\n		<div class="separator"></div>\n		<!--<div class="game-detail">-->\n			<!--';
 if(is_mobile) { 
__p+='-->\n				<!--<a target="_blank" href="https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252167;dc_trk_aid=521056745;dc_trk_cid=148493239;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=">-->\n			<!--';
 } else { 
__p+='-->\n				<!--<a target="_blank" href="https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252164;dc_trk_aid=521058920;dc_trk_cid=148493239;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=">-->\n			<!--';
 } 
__p+='-->\n				<!--<img src="/assets/images/sports-bet-logo-header.png" alt="SportsBet.com.au">-->\n			<!--</a>-->\n		<!--</div>-->\n\n		<div class="currency away-squad">\n			';
 if(is_mobile) { 
__p+='\n			<a target="_blank" href="https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252167;dc_trk_aid=521056745;dc_trk_cid=148493239;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=">\n				';
 } else { 
__p+='\n				<a target="_blank" href="https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252164;dc_trk_aid=521058920;dc_trk_cid=148493239;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=">\n					';
 } 
__p+='\n					'+
((__t=( away_squad_odds_currency ))==null?'':_.escape(__t))+
'\n				</a>\n		</div>\n	</div>\n';
 } 
__p+='\n\n';
 if(is_game_info_opened){ 
__p+='\n	<div class="tip-game-info js-tip-game-info">\n		<div class="tip-game-info-table">\n			<div class="tip-game-info-table-row">\n				<div class="tip-game-info-table-cell">'+
((__t=( game_info.trend[home_squad_id] ))==null?'':_.escape(__t))+
'%</div>\n				<div class="tip-game-info-table-cell tip-game-info-table-cell-title">User Tips</div>\n				<div class="tip-game-info-table-cell">'+
((__t=( game_info.trend[away_squad_id] ))==null?'':_.escape(__t))+
'%</div>\n			</div>\n			';
 if(!is_soo){ 
__p+='\n				<div class="tip-game-info-table-row">\n					<div class="tip-game-info-table-cell">'+
((__t=( _.ordinalSuffixOf(game_info.ladder[home_squad_id]) ))==null?'':_.escape(__t))+
'</div>\n					<div class="tip-game-info-table-cell tip-game-info-table-cell-title">Ladder Position</div>\n					<div class="tip-game-info-table-cell">'+
((__t=( _.ordinalSuffixOf(game_info.ladder[away_squad_id]) ))==null?'':_.escape(__t))+
'</div>\n				</div>\n			';
 } 
__p+='\n			\n			<div class="tip-game-info-table-row tip-game-info-table-row-slim">\n				<div class="tip-game-info-table-cell">\n					';
 _.each(game_info.last_5[home_squad_id], function(game){ 
__p+='\n						<div class="form-item '+
((__t=( game.wdl ))==null?'':_.escape(__t))+
'"><span>'+
((__t=( game.wdl === 'win' ? 'W' : 'L' ))==null?'':_.escape(__t))+
'</span></div>\n					';
 }) 
__p+='\n				</div>\n				<div class="tip-game-info-table-cell tip-game-info-table-cell-title">Form</div>\n				<div class="tip-game-info-table-cell">\n					';
 _.each(game_info.last_5[away_squad_id], function(game){ 
__p+='\n						<div class="form-item '+
((__t=( game.wdl ))==null?'':_.escape(__t))+
'"><span>'+
((__t=( game.wdl === 'win' ? 'W' : 'L' ))==null?'':_.escape(__t))+
'</span></div>\n					';
 }) 
__p+='\n				</div>\n			</div>\n			<div class="tip-game-info-table-row">\n				<div class="tip-game-info-table-cell">'+
((__t=( game_info.head_to_head[home_squad_id].wins ))==null?'':_.escape(__t))+
' ('+
((__t=( game_info.head_to_head[home_squad_id].wins_pct ))==null?'':_.escape(__t))+
'%)</div>\n				<div class="tip-game-info-table-cell h2h-line-cell">\n					<div class="h2h-line-container h2h-line-container-left">\n						<div style="width: '+
((__t=( game_info.head_to_head[home_squad_id].wins_pct ))==null?'':_.escape(__t))+
'%" class="green h2h-line"></div>\n					</div>\n					<div class="tip-game-info-table-cell-title">H2H</div>\n					<div class="h2h-line-container h2h-line-container-right">\n						<div style="width: '+
((__t=( game_info.head_to_head[away_squad_id].wins_pct ))==null?'':_.escape(__t))+
'%" class="red h2h-line"></div>\n					</div>\n				</div>\n				<div class="tip-game-info-table-cell">'+
((__t=( game_info.head_to_head[away_squad_id].wins ))==null?'':_.escape(__t))+
' ('+
((__t=( game_info.head_to_head[away_squad_id].wins_pct ))==null?'':_.escape(__t))+
'%)</div>\n			</div>\n			<a class="tip-game-info-link" href="'+
((__t=( full_match_url ))==null?'':_.escape(__t))+
'" target="_blank">\n				<span>View Full Match Centre</span>\n				<i class="ion-chevron-right"></i>\n			</a>\n		</div>\n		\n	</div>\n';
 } 
__p+='';
}
return __p;
};
